import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

library.add(faUserSecret, faEyeSlash, faEye, faCheck);
Vue.component("font-awesome-icon", FontAwesomeIcon);

import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import moment from "moment-timezone";

import VueQrcodeReader from "vue-qrcode-reader";
import { io } from "socket.io-client";
import helpers from "./plugins/helpers";

Vue.use(VueQrcodeReader);

moment.locale("id");
Vue.prototype.$moment = moment;

Vue.use(ToastPlugin);
// Setel jQuery ke instance Vue untuk digunakan secara global jika diperlukan

Vue.config.productionTip = false;

const SocketPlugin = {
  install(Vue) {
    Vue.prototype.$socket = io(process.env.VUE_APP_SOCKET_URL)
  }
}
Vue.use(SocketPlugin)

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: process.env.VUEA_APP_SOCKET_URL,
//   vuex: {
//       store,
//       actionPrefix: 'SOCKET_',
//       mutationPrefix: 'SOCKET_'
//   },
// }))

new Vue({
  router,
  render: (h) => h(App),
  store,
	mixins: [Vue.mixin(helpers)],
}).$mount("#app");
